import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.33 15h4.584v1.041a2.292 2.292 0 0 1-4.583 0zm3.383-3.334.037-.11c.639-1.755.747-2.08.747-2.39 0-.624-.168-1.369-.44-1.894-.201-.391-.343-.505-.393-.505-1.066 0-2.083 1.136-2.083 2.4 0 .798.062 1.477.189 2.298l.032.201zM6.664 5.1c1.667 0 2.5 2.4 2.5 4.066 0 .834-.417 1.667-.833 2.917l-.417 1.25H3.331c0-.833-.417-2.083-.417-4.167S4.58 5.1 6.664 5.1m10.045 6.648-.18 1.026a2.292 2.292 0 0 1-4.514-.796l.18-1.026zm-.874-3.539c.137-.416.25-.745.252-.75.168-.548.3-1.085.404-1.673.22-1.243-.585-2.54-1.635-2.724-.05-.01-.209.079-.475.429-.358.47-.654 1.174-.762 1.789-.049.275-.041.337.225 1.886.036.212.068.404.096.597l.017.115zm-.69-6.789c2.054.362 3.35 2.604 2.987 4.656-.361 2.051-.989 3.21-1.134 4.03l-4.513-.795-.194-1.303c-.193-1.304-.458-2.197-.314-3.018.29-1.64 1.527-3.86 3.168-3.57"
    }, null, -1)
  ]))]))
}
export default { render: render }